import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Chip, Container, Grid, Stack, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';

import PageHeader from './PageHeader';
import { SITE_URL } from '../../lib/seo';
import { tArray } from '../../lib/i18nSafe';

const TYPE_COLOR = {
  Launch: 'success',
  Model: 'primary',
  Improvement: 'secondary',
  Policy: 'warning',
  Research: 'info'
};

export default function Changelog() {
  const { t } = useTranslation();
  const entries = tArray(t, 'changelog.entries');

  return (
    <Box>
      <Helmet>
        <title>Changelog | Al-Amen Technology</title>
        <link rel="canonical" href={`${SITE_URL}/changelog`} />
      </Helmet>
      <PageHeader
        eyebrow={t('changelog.eyebrow')}
        title={t('changelog.title')}
        body={t('changelog.body')}
      />

      <Container maxWidth="xl" sx={{ py: { xs: 5, md: 8 } }}>
        <Stack spacing={0}>
          {entries.map((e, idx) => (
            <Box
              key={e.date + e.title}
              sx={{
                py: { xs: 4, md: 5 },
                borderTop: idx === 0 ? '1px solid' : 'none',
                borderBottom: '1px solid',
                borderColor: 'divider'
              }}
            >
              <Grid container spacing={3}>
                <Grid item xs={12} md={3}>
                  <Typography
                    sx={{
                      fontFamily: 'var(--font-mono)',
                      fontSize: '0.82rem',
                      color: 'text.secondary',
                      textTransform: 'uppercase',
                      letterSpacing: '0.1em'
                    }}
                  >
                    {e.date}
                  </Typography>
                  <Chip
                    label={e.type}
                    size="small"
                    color={TYPE_COLOR[e.type] || 'default'}
                    sx={{ mt: 1 }}
                  />
                </Grid>
                <Grid item xs={12} md={9}>
                  <Typography
                    sx={{
                      fontFamily: 'var(--font-serif)',
                      fontSize: { xs: '1.6rem', md: '1.9rem' },
                      letterSpacing: '-0.02em',
                      lineHeight: 1.1,
                      mb: 1
                    }}
                  >
                    {e.title}
                  </Typography>
                  <Typography sx={{ color: 'text.secondary' }}>{e.body}</Typography>
                  {e.tags && e.tags.length ? (
                    <Stack direction="row" spacing={1} sx={{ mt: 2, flexWrap: 'wrap', gap: 1 }}>
                      {e.tags.map((tag) => (
                        <Chip key={tag} label={tag} size="small" variant="outlined" />
                      ))}
                    </Stack>
                  ) : null}
                </Grid>
              </Grid>
            </Box>
          ))}
        </Stack>
      </Container>
    </Box>
  );
}
